export default class PageManager {

	/**
	 * Constructor for PageManager class
	 *
	 * @param {Object} pageContext The Miva to JS namespace object (ex: mivaJS)
	 */
	constructor (pageContext) {
		this.pageContext = pageContext;
	}

	/**
	 * Callback function after DOMContentLoaded event
	 */
	// eslint-disable-next-line no-empty-function
	onReady () {
	}

	/**
	 * Static method used to dynamically load a PageManager instance and listen for onReady state
	 *
	 * @param {Object} pageContext The Miva to JS namespace object (ex: mivaJS)
	 */
	static load (pageContext) {
		const page = new this(pageContext);
		const callback = () => {
			page.onReady.bind(page)();
		};

		if (
			document.readyState === 'complete' ||
			// eslint-disable-next-line no-extra-parens
			(document.readyState !== 'loading' && !document.documentElement.doScroll)
		) {
			callback();
		} else {
			document.addEventListener('DOMContentLoaded', callback);
		}
	}
};
